import React from "react";
import StickyBar from "../ui/StickyBar";

/** Fixed thumb-zone action bar for demo workflow pages. */
export default function DemoStickyBar({ children, testId }) {
  return (
    <StickyBar variant="blur" testId={testId} innerClassName="flex gap-3">
      {children}
    </StickyBar>
  );
}
